module.exports = __webpack_public_path__ + "static/media/amphibious_logo@3x.30ed262c.svg";